import axios from 'axios'
import auth from '@it-enterprise/jwtauthentication/dist/jwtauthentication.umd.min.js'
import { getApplicationName } from '@/tools/'
const instance = axios.create()

instance.interceptors.request.use(async function (config) {
  const token = await auth.getToken()
  if (!token) {
    return config
  }
  
  config.headers.Authorization = `Bearer ${token}`
  config.headers['Application-Name'] = getApplicationName()
  return config
})

export default instance